import { Component } from '@angular/core';

@Component({
  selector: 'tun-edit-arrow-right-icon',
  templateUrl: './edit-arrow-right-icon.component.html'
})
export class EditArrowRightIconComponent {
}
